import { OrganizationChartItemType } from '../../../../../models/ts/organization-chart-item-type.model';

export const ORG_CHART_ITEM_TYPE_ICONS: { [itemType: number]: string } = {
  [OrganizationChartItemType.None]: 'x',
  [OrganizationChartItemType.User]: 'user',
  [OrganizationChartItemType.Function]: 'users',
  [OrganizationChartItemType.Department]: 'building',
  [OrganizationChartItemType.Entity]: 'building-columns',
  [OrganizationChartItemType.CurrentUser]: 'circle-user',
  [OrganizationChartItemType.API]: 'gear',
}